import createContentReducer from '../utils/createContentReducer';
import { RULES } from '../constants/apiTypes';
import decodeContent from '../normalizers/decodeContent';

const decodeRules = decodeContent({
  itemsKey: 'rules',
  nameKey: 'name',
  titleKey: 'title',
  contentKey: 'content'
});

const rulesReducer = createContentReducer(RULES, {
  normalizeData: decodeRules
});

export default rulesReducer;
